module.exports = __webpack_public_path__ + "static/media/emoji.6a45b7d6.gif";